import download from 'downloadjs';
import { toast } from 'react-toastify';
import watermark from 'watermarkjs';
import { iTHREE } from '@treedis/tour-loader';
import { TagType, Transition } from '@/_models/Tag';
import { Menu, MenuType } from '@/_models/Menu';
import { TourMode, TourType } from '@/_models/Tour';
import { ChapterType } from '@/_models/game/GameBook';
import { buildLink, getAllQueryVariables, getQueryVariable, getVersion, getVideoLink } from './all';
import socket from './socket';
// import { sendToGA } from './analytic';
import { processNavigationPath } from '../tour/processNavigationPath';
import { moveToSweeps } from '../tour/moveToSweeps';
import { EntityType, LockLocationType } from '@/_models/Game';

// Interface for loadModel parameter
interface LoadModelParams {
  id?: number;
  name?: string;
  title?: string;
  label?: string;
  url?: string;
  type: string;
  tag?: string;
  panoramaId?: number;
  changeMinimap?: boolean;
  changePanorama?: boolean;
  iframeSettings?: any;
  changeReel?: boolean;
  gallery?: any[];
  file?: string;
  document?: any[];
  // Additional properties from TBurgerMenu
  icon?: any;
  order?: number;
  labelId?: any;
  floorId?: any;
  shouldHighlight?: boolean;
  createdAt?: string;
  updatedAt?: string;
  tourId?: number;
  subMenus?: any[];
  subSubMenus?: any[];
  open?: boolean;
  iconColor?: string;
  iconOpacity?: number;
  iconType?: string;
  iconFile?: any;
  active?: boolean;
  searchEnabled?: boolean;
  view?: string;
}
import { AudioModule, MusicObj } from '../../components-new/common/AudioModule';
import { videoRendererType } from '@/_models/virtualStaging/VideoRenderer.component';
import { extractSweepIdFromURL } from '@/utils/extractSweepIdFromURL';
import { getDistance } from '@/utils/getDistance';
import { pipesConfig } from '@/_models/virtualStaging/BIM/component/data';

function downloadDirect(url: string, title: string) {
  const element = document.createElement('a');
  element.setAttribute('href', url);
  element.setAttribute('download', `${title}.jpg`);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export function takePano() {
  if (this.showcase) {
    this.setState({ loading: true });
    this.showcase.Renderer.takeEquirectangular().then((url) => {
      downloadDirect(url, this.state.tour.title);
      this.setState({ loading: false });
    });
  }
}

export function getLocation() {
  const m = getQueryVariable(this.state.iframeUrl, 'm');
  if (m) {
    return buildLink(this.pose.sweep, this.pose.rotation, m);
  }
  return null;
}

const audioHandler = AudioModule.getInstance();

function downloadImage(title: string, url: string, clientId: number | null, width: number) {
  const options = {
    init(img) {
      // eslint-disable-next-line no-param-reassign
      img.crossOrigin = 'anonymous';
    },
  };
  watermark(
    [url, `${process.env.NEXT_PUBLIC_CDN}/clients/${clientId}/logo.png${getVersion(new Date())}`],
    options,
  )
    .blob((target, _watermark) => {
      const context = target.getContext('2d');
      context.save();

      const widthRatio = _watermark.width / width;
      const height = _watermark.height / widthRatio;
      context.drawImage(_watermark, 10, 10, width, height);

      context.restore();
      return target;
    })
    .then((img) => download(img, `${title}.jpg`, 'image/jpg'));
}

export function takeScreenshot(resolution) {
  if (this.showcase) {
    const { tour } = this.state;
    const width = tour.client && tour.client.widthLogo ? 250 : 150;
    this.setState({ loading: true });
    const sweep = this.state.sweeps?.find(
      (sweep) =>
        sweep.id === this.state.currentSweep.sid ||
        sweep.sweep_uuid === this.state.currentSweep.sid,
    );

    let { title } = tour;

    if (sweep) {
      title = `${sweep.id}_${sweep.sweep_uuid}`;
    }

    this.showcase.Renderer.takeScreenShot(resolution, {
      mattertags: false,
      sweeps: false,
    }).then((url) => {
      if (tour.client && tour.client.logo) {
        downloadImage(title, url, tour.clientId, width);
      } else {
        downloadDirect(url, title);
      }
      this.setState({ loading: false });
    });
  }
}

export function preventTagAction(sid, actions) {
  if (this?.showcase) {
    // eslint-disable-next-line no-console
    return this.showcase.Mattertag.preventAction(sid, actions).catch(console.error);
  }
  return null;
}

export async function navigateToTag(sid) {
  if (this?.showcase) {
    const preventAction = preventTagAction.bind(this);
    await preventAction(sid, { navigation: false });
    // eslint-disable-next-line no-console
    await this.showcase.Mattertag.navigateToTag(sid, this.showcase.Mattertag.Transition.FLY).catch(
      console.error,
    );
    await preventAction(sid, { navigation: true });
  }
}

export async function loadModel(menu: LoadModelParams) {
  // Extract properties from menu object with defaults
  const {
    name = menu.title || menu.label, // fallback to title or label if name not provided
    url,
    type,
    tag,
    panoramaId,
    changeMinimap = true,
    changePanorama = false,
    iframeSettings = {},
    changeReel = false,
    gallery = [],
    file,
    document,
  } = menu;
  if (type === MenuType.Tab) {
    window.open(url);
  } else if (type === MenuType.Gallery) {
    // this.setState({ galleryOpen: true, menuOpen: false });
    if (gallery?.length > 0) {
      this.setState({
        galleryArr: gallery,
        // menuOpen: false,
        galleryName: name,
        galleryType: MenuType.Gallery,
      });
    }
  } else if (type === MenuType.Document) {
    this.setState({
      document: document || file,
      // menuOpen: false,
      documentName: name,
      documentType: MenuType.Document,
    });
  } else if (type === MenuType.FloorPlan) {
    this.setState({
      document: document || file,
      // menuOpen: false,
      documentName: name,
      documentType: MenuType.FloorPlan,
    });
  } else if (type === MenuType.Popup) {
    this.toggleExternalPopup(url);
  } else if (type === MenuType.Iframe) {
    this.toggleExternalPopup(url, iframeSettings);
  } else if (type === MenuType.Product && tag !== null) {
    const products = this.state.products.filter((item) => {
      return (item?.tags || []).some((productTag: { sid: string }) => productTag.sid === tag);
    });
    if (products && products.length > 0) {
      this.setState({
        currentProducts: products.length > 1 ? products : [],
        currentProduct: products.length === 1 ? products[0] : null,
      });
    }
    navigateToTag(tag);
    window.location.hash = tag;
  } else if (type === MenuType.Panorama) {
    this.setState({
      panoramaOn: true,
      activePano: panoramaId,
    });
  } else if (type === MenuType.Treedis) {
    // if moving to experience, we must clear memory by changing the location
    if (window.top !== window.self) {
      window.top.postMessage(
        {
          type: 'tourLink',
          url,
        },
        '*',
      );
      // so the parent window can handle the link
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    if (url.includes('/experience/')) {
      window.location.href = url;
      return;
    }

    const { tour } = this.state;
    const segments = url.split('/');
    const lastSeg = segments[segments.length - 1].split('?');
    const [slug] = lastSeg;
    const sameTour = tour.slug === slug;

    if (sameTour && lastSeg.length === 1) return; // same tour, no query params, we shouldn't get it again
    if (url.includes('matterport.com')) {
      toast.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
      return;
    }
    // if isVSReady is true, then VS is configured (VS components, lights etc.) - can't init VS without it
    // don't need to configure that if it's the same tour
    this.setState({ panoramaOn: false, activePano: null, isVSReady: sameTour, showLayers: false }, async () => {
      this.getTour({
        slug,
        changeMenu: false,
        changeMinimap,
        changePanorama,
        changeReel,
        url,
        hideIntroScreen: true,
      }); // false = dont change the menu/panorama
      // change url to detect tour analytic from menu
      try {
        window.history.pushState({}, '', url);
      } catch (error) {
        console.warn('Failed to update URL:', error);
        // Fallback if needed or just continue execution
      }
    });
  } else if (type === MenuType.MatterportInstant) {
    this.setState(
      { isChangeIframe: this.state.iframeUrl.matterId !== getQueryVariable(url, 'm'), showLayers: false },
      () => {
        this.moveModel(
          `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
            this.state.tour?.user?.mpSDK
          }${getAllQueryVariables(url)}`,
          false,
          true,
        );
      },
    );
  } else if (type === MenuType.Tag && tag !== null) {
    const target = Array.from(this.state.allTags, ([, value]: any) => value)
      // searching by temporary sid from Matterport
      .find((item: any) => item.sid === tag || item.defaultSid === tag);
    if (target?.media?.type === 'video' || target?.type === 'video') {
      audioHandler.pauseAllMusic();
      this.setState({
        tourAudioPlaying: false,
      });
    }

    target.tag = target;

    if (!target) {
      toast.error('Cannot find the tag on the tour');
      return;
    }

    // manually close all matter tag popups by navigation to new tag
    const { allTags } = this.state;
    Array.from(allTags.values()).forEach(({ sid }) => {
      this.showCaseTemp.showcase.Tag.close(sid);
    });

    if (target.treedisStyle && !target.navigationEnabled) {
      setTimeout(() => {
        this.handleTagHoverEvent(target.sid, true);
      }, 1000);
    }

    if (!this.showCaseTemp.navigationManager) return;

    let { currentSID } = this.showCaseTemp.navigationManager;
    if (!currentSID) {
      // If no sweep is set, use sweep from queryParam
      const s = getQueryVariable(window.location.href, 's');
      const currentSweep = this.state?.sweeps?.find(
        (sweep) => sweep.id === s || sweep.sweep_uuid === s,
      );
      if (!currentSweep) return;
      this.showCaseTemp.navigationManager.currentSweep = currentSweep;
      this.showCaseTemp.navigationManager.currentSID = currentSweep.id;
      currentSID = currentSweep.id;
    }

    const targetPosition = { x: target.positionX, y: target.positionY, z: target.positionZ };

    let closestSweep;
    let closestDistance = Infinity;
    this.state.allSweeps.forEach((sweep) => {
      if (sweep.floor === target.floor) {
        const sweepPosition = { x: sweep.positionX, y: sweep.positionY, z: sweep.positionZ };
        const distance = getDistance(sweepPosition, targetPosition);
        if (
          (closestDistance === null || distance < closestDistance) &&
          sweep.neighbourSweeps.length
        ) {
          closestSweep = sweep;
          closestDistance = distance;
        }
      }
    });

    // If sweep is very far or doesn't exist, try to find the closest sweep on any floor
    if (!closestSweep || closestDistance > 25) {
      closestDistance = Infinity;
      console.warn(
        "No sweep found on the same floor or it's too far. Defaulting to closest sweep on any floor.",
      );
      this.state.allSweeps.forEach((sweep) => {
        const sweepPosition = { x: sweep.positionX, y: sweep.positionY, z: sweep.positionZ };
        const distance = getDistance(sweepPosition, targetPosition);
        if (
          (closestDistance === null || distance < closestDistance) &&
          sweep.neighbourSweeps.length
        ) {
          closestSweep = sweep;
          closestDistance = distance;
        }
      });
    }
    const targetSID = closestSweep ? closestSweep.id : null;

    if (!currentSID || !targetSID) {
      console.error('Current or Target sweep not found', currentSID, targetSID);
      return;
    }

    if (!this.showCaseTemp.navigationManager) {
      console.error('PathFinder Line is not defined');
      return;
    }

    if (!target.navigationEnabled || target.AROnly) {
      if (this.showCaseTemp.navigationManager.targetObjectData?.id === target?.id) {
        this.showCaseTemp.navigationManager.reset();
        this.setActionPathNavbarVisible(false);
      }
      this.setState({ panoramaOn: false }, () => {
        this.moveToTagIO(target, false);
      });
      return;
    }

    // uncomment if LOS check must be added
    // const isLOS = target.dummyObject && this.showCaseTemp.navigationManager.component.frustum.intersectsObject(target.dummyObject);

    const distance = getDistance(this.pose.position, targetPosition);
    const inDistance =
      distance < 3 &&
      (this.state.currentFloor === target.floor || this.state.currentFloor === null) &&
      this.currentSweep.id !== '';

    if (inDistance) {
      this.showCaseTemp.navigationManager.reset();
      this.setActionPathNavbarVisible(false);
      this.setState({ panoramaOn: false }, () => {
        this.moveToTagIO(target, false);
      });
      return;
    }

    this.setState({
      actionPathNavbarData: {
        enableNavBar: target.enableNavBar,
        destinationTitle: target.title,
        icon: target.iconFile
          ? `${process.env.NEXT_PUBLIC_CDN}/tours/${target.tourId}/tags/icons/${target.iconFile}`
          : null,
        autoNavigation: target.autoNavigation,
        enableTeleportBtn: target.enableTeleportBtn,
      },
    });

    if (
      this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.DOLLHOUSE ||
      this.state.tourMode === this.showCaseTemp.showcase.Mode.Mode.FLOORPLAN
    ) {
      this.setActionPathNavbarPlayButtonType('Play');
      this.showCaseTemp.navigationManager.renderPath(this.prevSweep.id, targetSID, name, target);
      return;
    }

    if (target.autoNavigation) {
      if (
        target.navigationAutoPlay &&
        this.showCaseTemp.navigationManager.targetObjectData?.id !== target?.id
      ) {
        if (this.currentSweep.id === '') {
          // start automatic navigation after sweep transition is finished
          const intervalID = setInterval(() => {
            if (this.currentSweep.id !== '') {
              this.showCaseTemp.navigationManager.reset();
              this.setActionPathNavbarPlayButtonType('Pause');
              this.showCaseTemp.navigationManager
                .renderPath(this.currentSweep.id, targetSID, name, target)
                .then(() => {
                  this.showCaseTemp.navigationManager
                    .autoNavigateCurrentPath(
                      null,
                      // eslint-disable-next-line @typescript-eslint/no-empty-function
                      () => {},
                      () => {
                        this.showCaseTemp.navigationManager.inAutoNavigate = false;
                        this.setActionPathNavbarPlayButtonType('Play');
                      },
                    )
                    .catch((e) => console.error(e));
                });
              clearInterval(intervalID);
            }
          }, 250);
        } else {
          this.showCaseTemp.navigationManager.reset();
          this.setActionPathNavbarPlayButtonType('Pause');
          this.showCaseTemp.navigationManager
            .renderPath(currentSID, targetSID, name, target)
            .then(() => {
              this.showCaseTemp.navigationManager
                .autoNavigateCurrentPath(
                  null,
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  () => {},
                  () => {
                    this.showCaseTemp.navigationManager.inAutoNavigate = false;
                    this.setActionPathNavbarPlayButtonType('Play');
                  },
                )
                .catch((e) => console.error(e));
            });
        }
      } else {
        this.setActionPathNavbarPlayButtonType('Play');
        this.showCaseTemp.navigationManager
          .renderPath(currentSID, targetSID, name, target)
          .then(() => {
            this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
          });
      }
      return;
    }

    if (this.showCaseTemp.navigationManager.targetObjectData?.id !== target?.id) {
      this.setActionPathNavbarPlayButtonType('Play');
      this.showCaseTemp.navigationManager
        .renderPath(currentSID, targetSID, name, target)
        .then(() => {
          this.showCaseTemp.navigationManager.rotateCameraToPathDirection();
        });
    } else {
      return;
    }
  } else if (type === MenuType.NavigationPath) {
    const currentSID =
      this.state.currentSweep.sid || this.state.currentSweep.sweep || this.defaultSweep?.sid;
    const targetSID = extractSweepIdFromURL(url);

    if (!currentSID) {
      console.error('Current sweep not found');
      return;
    }
    if (!targetSID) {
      console.error('Target sweep not found');
      return;
    }

    if (this.showCaseTemp.navigationManager) {
      if (this.showCaseTemp.navigationManager.targetSID !== targetSID) {
        const allSweeps = this.state.allSweeps?.size
          ? Array.from(this.state.allSweeps, ([, value]: any) => value)
          : [];
        if (allSweeps.length === 0) {
          toast.info(
            this.state.translation?.pleaseWaitSweeps || 'Please wait for the sweeps to load',
          );
          return;
        }
        const target = allSweeps?.find(
          (item: any) => item.sweep_uuid === targetSID || item.sweepId === targetSID,
        );
        this.showCaseTemp.navigationManager.renderPath(
          this.showCaseTemp.navigationManager.currentSID,
          target?.id,
          name,
          target,
          this.showCaseTemp.navigationManager.navigationType,
        );
      } else {
        this.showCaseTemp.navigationManager.reset();
      }
    }
  } else if (type === MenuType.BIMItem) {
    // this.BIMComponent.setItemColor(url, this.BIMComponent.inputs.colorClick);
    // this.BIMComponent.setItemOpacity(url, this.BIMComponent.inputs.opacityClick);

    const component = this.BIMComponent;
    // @ts-ignore valid comparison for BIM component
    const pipeConfig = pipesConfig.pipes.find((el) => el.id === url);
    const selectedPipe = [
      ...pipeConfig.segments.map((s) => s.name),
      ...pipeConfig.animatedSegments.map((s) => s.name),
    ];

    if (component.selectedPipe) {
      component.selectedPipe.forEach((segment) => {
        const segmentId = component.getSegmentIdByName(segment);
        if (segmentId) {
          component.setItemColor(segmentId, component.inputs.colorDefault);
          component.setItemOpacity(segmentId, component.inputs.opacityDefault);
          if (component.animatedPipes.has(segmentId)) {
            component.setAnimatedPipeOpacity(segmentId, 0);
          }
          const segmentItem = component.getItem(segmentId);
          if (segmentItem) segmentItem.selected = false;
        }
      });
      component.selectedPipe = null;
    }

    selectedPipe.forEach((segment) => {
      const segmentId = component.getSegmentIdByName(segment);
      if (segmentId) {
        component.setItemColor(segmentId, component.inputs.colorClick);
        component.setItemOpacity(segmentId, component.inputs.opacityClick);
        if (component.animatedPipes.has(segmentId)) {
          component.setAnimatedPipeOpacity(segmentId, 1);
        }
        const segmentItem = component.getItem(segmentId);
        if (segmentItem) segmentItem.selected = true;
      }
    });

    component.selectedPipe = selectedPipe;
  } else if (type !== MenuType.Category) {
    this.setState(
      { isChangeIframe: this.state.iframeUrl.matterId !== getQueryVariable(url, 'm') },
      () => {
        this.moveModel(
          `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
            this.state.tour?.user?.mpSDK
          }${getAllQueryVariables(url)}`,
          false,
          false,
        );
      },
    );
  }
  // DISabling GA for now
  // if (name) {
  //   sendToGA('event', {
  //     eventCategory: 'Place',
  //     eventAction: 'click',
  //     eventLabel: name,
  //   });
  // }

  if (name && this.state.chatToken && socket && socket.connected && this.state.host) {
    socket.emit('menu', {
      menu: {
        name,
        url,
        type,
      },
    });
  }
}

export async function openedPanoHotspot(hotspot: any) {
  if (hotspot.type === TagType.Matterport && hotspot.url) {
    if (this.state.appState !== 'playing') {
      toast.info(this.state.translation?.pleaseWait || 'Please wait for the tour to load');
      return;
    }
    this.moveModel(
      `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
        this.state.tour?.user?.mpSDK
      }${getAllQueryVariables(hotspot.url)}`,
      false,
      true,
    );
    return;
  }
  if (hotspot.type === TagType.MatterportInstant && hotspot.url) {
    if (this.state.appState !== 'playing') {
      toast.info(this.state.translation?.pleaseWait || 'Please wait for the tour to load');
      return;
    }
    this.moveModel(
      `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
        this.state.tour?.user?.mpSDK
      }${getAllQueryVariables(hotspot.url)}`,
      false,
      false,
    );
    return;
  }

  if (hotspot.type === TagType.Treedis && hotspot.url) {
    const windowSegments = window.location.href.split('/');
    const segments = hotspot.url.split('/');
    const slug = hotspot.url.includes('?')
      ? segments[segments.length - 1].split('?')[0]
      : segments[4];
    const hubRegex = /(^|[^a-z])(host|guest)([^a-z]|$)/i;
    const gameOrVcommerceRegex = /(^|[^a-z])(experience|e-commerce-tour)([^a-z]|$)/i;
    const isHubUrl = hubRegex.test(hotspot.url);
    const isGameOrVCommerce = gameOrVcommerceRegex.test(hotspot.url);
    const room = isHubUrl ? segments[segments.length - 1] : this.state.room || null;
    if (getQueryVariable(hotspot.url, 'm')) {
      toast.error("Can't use this link, to copy location in treedis tour, use CTRL+Y");
      return;
    }

    if (isGameOrVCommerce) {
      const tourSlug = windowSegments.pop().split('?')[0];
      if (tourSlug !== slug) {
        window.location.assign(hotspot.url);
        return;
      }
    }
    const { tour } = this.state;
    const changeMinimap = tour && !tour.customMinimap;

    if (tour.slug !== slug) {
      await this.getTour({
        slug,
        changeMenu: false,
        changeMinimap,
        changePanorama: false,
        url: hotspot.url,
        hideIntroScreen: true,
      }); // false = dont change the menu/panorama
    } else {
      if (this.state.appState !== 'playing') {
        toast.info(this.state.translation?.pleaseWait || 'Please wait for the tour to load');
        return;
      }

      const s = getQueryVariable(hotspot.url, 's');
      const x = getQueryVariable(hotspot.url, 'x');
      const y = getQueryVariable(hotspot.url, 'y');

      // eslint-disable-next-line
      if (s && x && y) {
        // We move inside the tour
        await this.moveToSweep(String(s), { x: parseFloat(x), y: parseFloat(y) });
      }
    }

    if (!socket.connected && isHubUrl) {
      socket.open();
    }
    this.setState(
      {
        panoramaOn: false,
        activePano: null,
        isVSReady: false,
        room,
        interacted: true,
      },
      async () => {
        if (this.state.room && socket && socket.connected && this.state.host) {
          socket.emit('pano-hotspot-click', {
            id: slug,
            changeMenu: false,
            changeMinimap,
            changePanorama: false,
            url: hotspot.url,
          });
        }
      },
    );
    return;
  }

  if (hotspot.type === TagType.Music && hotspot.url) {
    const { tour } = this.state;
    if (tour.noAudioMode && this.state.chatToken) return;
    this.setState({
      openedPanoHotspot: hotspot,
    });
    await audioHandler.playAudio({ type: MusicObj.PANORAMAS, id: hotspot.defaultId });
    return;
  }

  if (hotspot.type === TagType.Popup && hotspot.url) {
    const { noAudioMode } = this.state?.tour;
    hotspot.url = getVideoLink(hotspot.url, {
      mute: noAudioMode && this.state.chatToken,
    });
    audioHandler.pauseAllMusic();
  }
  this.setState({
    panoPopOn: true,
    openedPanoHotspot: hotspot,
  });
}

export async function openTagIframe(sid: string, options?: { skipEmbedMediaCheck?: boolean }) {
  const { allTags, tour, tourType } = this.state;
  const { skipEmbedMediaCheck = false } = options || {};
  // already we have tag why we find one else
  const foundTag = Array.from(allTags, ([, value]: any) => value)
    // searching by temporary sid from Matterport
    .find((item: any) => item.sid === sid || item.defaultSid === sid);

  if (foundTag) {
    if (!foundTag.type) return null;

    const tag = { ...foundTag };

    // Allow tag.type with NONE who participate in game actions like chapter, lock
    if (tour?.gameId && tourType === TourType.Game) {
      this.unlockChapter(tag, ChapterType.Tag);
      if (this.handleTagLock(tag)) return null;
    } else if (tour?.gameId) {
      this.setState({
        clickedElement: {
          id: tag.id,
          sid: tag.sid,
          defaultSid: tag.defaultSid,
          type: EntityType.Tag,
        },
      });
    }
    if (tag?.type === TagType.None) {
      return null;
    }
    if (tag?.type === TagType.Popup || tag?.type === TagType.Iframe) {
      this.setTagPopupOpen(true, false);
      return null;
    }
    if (tag?.type === TagType.Navigation) {
      if (this.state.tour?.showNavTools) {
        processNavigationPath({
          tagNavigationLink: tag.navigationLink,
          sweeps: this.state.sweeps,
          startSweep: this.pose.sweep,
          cb: ({ sweepsPath, rotation }) => {
            const { rotationAngle, rotationSpeed, transitionSpeed, stopAfterSweep } =
              this.state.tour;
            moveToSweeps({
              sweepsPath,
              targetRotation: rotation,
              rotationAngle,
              rotationSpeed,
              transitionSpeed,
              stopAfterSweep,
              poseRotation: this.pose.rotation,
              showcaseSweep: this.showcase.Sweep,
            }).then(() => {
              this.setState({
                showPathFinderPopup: true,
              });
            });
          },
        });
      }
      return null;
    }
    if (
      !skipEmbedMediaCheck &&
      tag.embedMedia &&
      [TagType.Popup, TagType.Iframe].includes(tag.type)
    ) {
      return null;
    }
    if (tag.type === TagType.Panorama) {
      this.setState({
        activePano: tag.panoramaId,
        panoramaOn: true,
      });
      return null;
    }
    if (tag.type === TagType.Treedis && tag.url) {
      const segmants = tag.url.split('/');
      const lastSeg = segmants[segmants.length - 1].split('?');
      const slug = lastSeg[0];
      if (tour.slug === slug && lastSeg.length === 1) return null; // same tour, no query params, we shouldn't get it again

      if (getQueryVariable(tag.url, 'm')) {
        toast.error("Cannot use this link. To copy location in the tour, please use 'CTRL+Y'");
        return null;
      }
      const changeMinimap = tour && !tour.customMinimap;

      try {
        switch (tag.transition) {
          case Transition.FlyOver:
            const sweep = getQueryVariable(tag.url, 's');
            const x = getQueryVariable(tag.url, 'x');
            const y = getQueryVariable(tag.url, 'y');
            await this.moveToSweep(sweep, { x: x ? +x : 0, y: y ? +y : 0 }, 'FLY');
            break;
          case Transition.Instant:
            this.setState({ panoramaOn: false, activePano: null, isVSReady: false }, async () => {
              await this.stopVS();
              this.modelNodes = [];
              this.vsObjects = [];
              this.getTour({
                slug,
                changeMenu: false,
                changeMinimap,
                changePanorama: false,
                url: tag.url,
                hideIntroScreen: true,
              }); // false = dont change the menu/panorama
            });
            break;
          default:
            console.error('openTagIframe: Tag type unknown');
            break;
        }
      } catch (e) {
        console.error(e);
      }

      return null;

      // isVSReady - the VS should be initialized again
    }
    if (
      (tag.type === TagType.MatterportInstant ||
        (tag.type === TagType.Matterport && tag.transition === Transition.Instant)) &&
      tag.url
    ) {
      this.moveModel(
        `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
          this.state.tour?.user?.mpSDK
        }${getAllQueryVariables(tag.url)}`,
        false,
        true,
      );
      return null;
    }
    if (tag.type === TagType.Matterport && tag.url) {
      this.moveModel(
        `/mp-sdk/${process.env.NEXT_PUBLIC_MP_SDK_VERSION}/showcase.html?applicationKey=${
          this.state.tour?.user?.mpSDK
        }${getAllQueryVariables(tag.url)}`,
        false,
        false,
      );
      return null;
    }
    if (tag.type === TagType.Menu) {
      this.setState(
        {
          menuOpen: false,
          activeMenu: null,
        },
        () => {
          this.setState({
            menuOpen: true,
            menuOpened: true,
            activeMenu: {
              menuId: tag.menuId,
              subMenuId: tag.subMenuId,
              subSubMenuId: tag.subSubMenuId,
            },
          });
        },
      );
      return null;
    }
    if (tag.type === TagType.Popup && tag.url) {
      const { noAudioMode } = this.state?.tour;
      tag.url = getVideoLink(tag.url, {
        mute: noAudioMode && this.state.chatToken,
        autoplay: tag.autoPlay,
      });
      audioHandler.pauseAllMusic();
    }
    if (tag.type === TagType.Tab && tag.url) {
      window.open(tag.url);
      return null;
    }
    if (tag.type === TagType.Music && tag.url) {
      const { noAudioMode } = this.state?.tour;
      const disableActionForFlow = !!this.state.flowAssetsToDisableAction?.find(
        (a) => a.asset === 'tag' && a.assetId === tag.id,
      );

      if ((noAudioMode && this.state.chatToken) || disableActionForFlow) return null;
      const vsVideos = this.vsObjects?.filter(
        (obj) => obj.node?.componentType === videoRendererType,
      );
      vsVideos?.forEach((obj) => {
        const { video: vsVideo, muteBtn } = obj.node;
        if (muteBtn && !muteBtn.active) {
          vsVideo.muted = true;
          muteBtn.active = true;
          muteBtn.makeBtn(muteBtn.inputs.src);
        }
      });

      await audioHandler.playAudio({ type: MusicObj.TAGS, id: tag.id });
      return null;
    }
    if (tag.type === TagType.VideoChat) {
      this.setState({
        videoChatTagPopOn: true,
        openedTag: {
          ...tag,
          sid: tag.sid,
        },
      });
      audioHandler.pauseAllMusic();
      return null;
    }
    if (tag.type === TagType.ExperiencePopUp) {
      // We take the first image from the gallery now or the videoUrl for experiencePopUp
      const img = tag?.tagGalleries.find((g) => g.isImage);

      this.setState({
        tourMusicWasPaused: true,
        sweepMusicWasPaused: true,
        experiencePopUpIsOpen: true,
        closedElementPopup: false,
        experiencePopUpData: {
          title: tag?.title,
          url: img?.file || tag?.videoUrl || tag?.actionURL,
          description: tag?.description,
          defaultImageUrl: '',
          prefixImageUrl: `/tours/${this.state.tour?.id}/tags/`,
          rotation: tag?.rotation,
          backgroundColor: tag?.backgroundColor,
          backgroundOpacity: tag?.backgroundOpacity,
          textColor: tag?.textColor,
          buttonColor: tag?.buttonColor,
        },
      });
      return null;
    }

    if (tag.type === TagType.Flow) {
      this.setState({ startFlowFromAsset: tag.flowId });
      return null;
    }

    this.setState({
      tagPopOn: true,
      openedTag: tag,
      closedElementPopup: false,
    });

    return tag;
  }
  return null;
}

export async function moveToMPLabels(menu: Menu) {
  const { type, labelId, floorId } = menu;
  const { mpLabels, sweeps, mpFloors } = this.state;
  const THREE = await iTHREE();

  try {
    switch (type) {
      case MenuType.MatterportFloor:
        // ToDo: menu.floorId from old API so we can not be sure that it work constantly
        const floorIndex = mpFloors.findIndex((l) => String(l.id) === String(floorId));
        await this.changeViewMode(TourMode.FLOORPLAN);
        await this.changeFloor(floorIndex);
        break;
      case MenuType.MatterportLabel:
        const label = mpLabels.find((l) => l.sid === labelId);
        if (!label) console.error('Label not found');

        const sweepsOnFloor = sweeps.filter(
          (x) => x.floorInfo.id === label.floorInfo.id && x.enabled,
        );

        if (sweepsOnFloor.length === 0) console.error('Sweeps not found');

        const startPoint = new THREE.Vector3(label.position.x, label.position.y, label.position.z);
        const distances = sweepsOnFloor.map((sweep) => {
          const endPoint = new THREE.Vector3(sweep.position.x, sweep.position.y, sweep.position.z);
          const distance = Math.abs(startPoint.distanceTo(endPoint));
          return {
            distance,
            ...sweep,
          };
        });

        const sweepsWithMinDistance = distances.reduce((a, b) =>
          a?.distance <= b?.distance ? a : b,
        );
        // eslint-disable-next-line dot-notation
        await this.showcase.Sweep.moveTo(sweepsWithMinDistance['id'], {
          // eslint-disable-next-line dot-notation
          rotation: sweepsWithMinDistance['rotation'],
          transition: this.showcase.Mode.TransitionType.FLY,
        });
        break;
      default:
        console.error('moveToMPLabels: Menu type unknown');
        break;
    }
  } catch (e) {
    console.error(e);
  }
}

export async function openVsObjectIframe(vsObject: any) {
  const hasTourGameId = this.state.tour?.gameId;
  if (!hasTourGameId) return false;
  this.unlockChapter(vsObject, ChapterType.VSItem);
  const doVSAction = this.handleVsObjectLock(vsObject, LockLocationType.vsItem);
  return doVSAction;
}

export async function openVsImageIframe(vsImage: any) {
  const { tour } = this.state;
  if (tour?.gameId) {
    this.unlockChapter(vsImage, ChapterType.VSImage);
    if (this.handleVsObjectLock(vsImage, LockLocationType.vsImage)) return null;
  }

  return null;
}

export async function openVsVideoIframe(vsVideo: any) {
  const { tour } = this.state;
  if (tour?.gameId) {
    this.unlockChapter(vsVideo, ChapterType.VSVideo);
    if (this.handleVsObjectLock(vsVideo, LockLocationType.vsVideo)) return null;
  }

  return null;
}
